import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

export const ChevronRight = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE,
  styles = '~w-2/3 h-auto'
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      fill={fillColor}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
      className={styles}
      preserveAspectRatio='xMidYMid meet'>
      <g id='SVGRepo_iconCarrier'>
        <path d='m10.18 8.05-5.66 5.56.87.89 5.71-5.59a1.18 1.18 0 0 0 .39-.86 1.13 1.13 0 0 0-.39-.85L5.4 1.5l-.89.88z'></path>
      </g>
    </svg>
  );
};
